import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation JSON files
import ENTranslations from 'i18n/en/translations.json';
import MagicMovieTranslations from 'i18n/en/magicMovie.json';

const resources = {
  en: {
    translation: ENTranslations, // import JSON translation strings for each languages here.
    magicMovie: MagicMovieTranslations,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en', // English as fallback language
  // debug: true, // keeping it here to help quickly debug i18n issues.
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
